import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import { Form as FormComponent } from 'components/Form'
import { InputForm, TitleForm } from 'components/Form/components'
import { ApiErrors } from 'ui-components/ApiErrors'

export default function Form(props) {
  const {
    group,
    onCancel,
    onSave,
    saving,
    responseError,
  } = props

  const [attributes, setAttributes] = useState()

  useEffect(() => {
    setAttributes(group.attributes)
  }, [group])

  const handleSave = () => {
    onSave(attributes)
  }

  const handleChange = (evt) => {
    const { name, value } = evt.target
    setAttributes({
      ...attributes,
      [name]: value,
    })
  }

  return attributes ? (
    <FormComponent
      onCancel={onCancel}
      onSave={handleSave}
      saving={saving}
    >
      <TitleForm>Grupo de produto</TitleForm>
      <ApiErrors responseError={responseError} />
      <InputForm
        fullWidth
        label="Nome"
        type="text"
        name="name"
        value={attributes.name}
        onChange={handleChange}
      />
    </FormComponent>
  ) : null
}

Form.propTypes = {
  group: PropTypes.objectOf(PropTypes.any),
  onCancel: PropTypes.func.isRequired,
  onSave: PropTypes.func.isRequired,
  saving: PropTypes.bool,
  responseError: PropTypes.objectOf(PropTypes.any),
}

Form.defaultProps = {
  group: {},
  saving: false,
  responseError: {},
}
